<style scoped>
    .ai-chat-toggle {
        position: fixed;
        bottom: 20px;
        right: 20px;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        border: none;
        background: #1ab394;
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
        z-index: 2100;
    }

    .ai-chat-window {
        position: fixed;
        bottom: 80px;
        right: 20px;
        width: 360px;
        height: 480px;
        max-height: calc(100vh - 100px);
        transition: height 0.15s ease;
        display: flex;
        flex-direction: column;
        background: #fff;
        border: 1px solid #e7eaec;
        border-radius: 4px;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
        z-index: 2100;
    }

    .ai-chat-window.expanded {
        height: calc(100vh - 100px);
        width: 600px;
    }

    .ai-chat-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 15px;
        background: #1ab394;
        color: #fff;
        border-radius: 4px 4px 0 0;
    }

    .ai-chat-header a {
        color: #fff;
        cursor: pointer;
    }

    .ai-chat-header a + a {
        margin-left: 10px;
    }

    .ai-chat-agent {
        background: transparent;
        border: none;
        color: #fff;
        font-weight: bold;
        cursor: pointer;
    }

    .ai-chat-agent option {
        color: #333;
    }

    .ai-chat-context {
        padding: 6px 15px;
        background: #f3fbf9;
        border-bottom: 1px solid #e7eaec;
        color: #1ab394;
        font-size: 12px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .ai-chat-context-status {
        float: right;
        font-weight: bold;
        text-transform: uppercase;
    }

    .ai-chat-warning {
        padding: 6px 15px;
        background: #fff7e6;
        border-bottom: 1px solid #f5d789;
        color: #8a6d3b;
        font-size: 12px;
    }

    .ai-chat-warning a {
        color: #1ab394;
        font-weight: 600;
        cursor: pointer;
    }

    .ai-chat-messages {
        flex: 1;
        overflow-y: auto;
        padding: 15px;
    }

    .ai-chat-conversation {
        display: block;
        padding: 8px 10px;
        margin-bottom: 6px;
        border: 1px solid #e7eaec;
        border-radius: 4px;
        cursor: pointer;
        color: inherit;
    }

    .ai-chat-conversation:hover {
        background: #f3fbf9;
    }

    .ai-chat-conversation-title {
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .ai-chat-conversation-meta {
        display: block;
        font-size: 11px;
        color: #999;
    }

    .ai-chat-files {
        font-size: 11px;
        color: #676a6c;
        background: #f8f9fa;
        border: 1px solid #e7eaec;
        border-radius: 4px;
        padding: 6px 8px;
        margin-bottom: 10px;
    }

    .ai-chat-file {
        display: inline-block;
        margin-left: 8px;
        white-space: nowrap;
    }

    .ai-chat-message {
        margin-bottom: 10px;
        padding: 8px 12px;
        border-radius: 4px;
        max-width: 85%;
        white-space: pre-wrap;
        word-wrap: break-word;
    }

    .ai-chat-message.user {
        background: #1ab394;
        color: #fff;
        margin-left: auto;
    }

    .ai-chat-message.assistant {
        background: #f3f3f4;
        white-space: normal;
    }

    .ai-chat-message.assistant >>> p,
    .ai-chat-message.assistant >>> ul,
    .ai-chat-message.assistant >>> ol,
    .ai-chat-message.assistant >>> table,
    .ai-chat-message.assistant >>> pre,
    .ai-chat-message.assistant >>> h1,
    .ai-chat-message.assistant >>> h2,
    .ai-chat-message.assistant >>> h3,
    .ai-chat-message.assistant >>> h4 {
        margin: 0 0 8px;
    }

    .ai-chat-message.assistant >>> *:last-child {
        margin-bottom: 0;
    }

    .ai-chat-message.assistant >>> h1 { font-size: 15px; }
    .ai-chat-message.assistant >>> h2,
    .ai-chat-message.assistant >>> h3,
    .ai-chat-message.assistant >>> h4 { font-size: 13px; }

    .ai-chat-message.assistant >>> ul,
    .ai-chat-message.assistant >>> ol {
        padding-left: 18px;
    }

    .ai-chat-message.assistant >>> table {
        border-collapse: collapse;
        font-size: 12px;
    }

    .ai-chat-message.assistant >>> th,
    .ai-chat-message.assistant >>> td {
        border: 1px solid #ddd;
        padding: 3px 6px;
        text-align: left;
    }

    .ai-chat-message.assistant >>> th {
        background: #eee;
    }

    .ai-chat-message.assistant >>> code {
        background: #e8e8e8;
        border-radius: 3px;
        padding: 1px 3px;
        font-size: 0.9em;
    }

    .ai-chat-message.assistant >>> pre {
        background: #e8e8e8;
        border-radius: 3px;
        padding: 6px;
        overflow-x: auto;
    }

    .ai-chat-pending {
        font-size: 11px;
        color: #676a6c;
        padding: 4px 12px;
        border-top: 1px solid #e7eaec;
        background: #f8f9fa;
    }

    .ai-chat-pending a {
        color: #999;
        cursor: pointer;
        margin-left: 6px;
    }

    .ai-chat-input {
        display: flex;
        align-items: center;
        border-top: 1px solid #e7eaec;
        padding: 10px;
    }

    .ai-chat-attach {
        color: #676a6c;
        cursor: pointer;
        margin-right: 8px;
    }

    .ai-chat-input input[type=text] {
        flex: 1;
        margin-right: 10px;
    }
</style>

<template>
    <!-- Hidden on the full-page AI view, which replaces the popup there. -->
    <div v-if="$route.name !== 'ai.index'">
        <button class="ai-chat-toggle" @click="open = !open" title="AI Assistant">
            <i class="fal" :class="open ? 'fa-times' : 'fa-comment-alt-lines'"></i>
        </button>

        <div class="ai-chat-window" :class="{ expanded }" v-if="open">
            <div class="ai-chat-header">
                <select class="ai-chat-agent" v-model="agent" @change="startNew">
                    <option v-for="(label, value) in availableAgents" :key="value" :value="value">{{ label }}</option>
                </select>
                <span>
                    <a @click="expanded = !expanded" :title="expanded ? 'Shrink' : 'Enlarge'">
                        <i class="fal" :class="expanded ? 'fa-compress-alt' : 'fa-expand-alt'"></i>
                    </a>
                    <a @click="toggleHistory" title="Previous conversations"><i class="fal fa-history"></i></a>
                    <a @click="startNew" title="New conversation"><i class="fal fa-plus"></i></a>
                </span>
            </div>

            <div class="ai-chat-context" v-if="agent === 'sales' && contextOpportunity && !contextMismatch">
                <i class="fal fa-bullseye"></i>
                {{ contextOpportunity.formatted_name || contextOpportunity.name }}
                <span class="ai-chat-context-status">{{ contextOpportunity.status }}</span>
            </div>

            <div class="ai-chat-context" v-if="agent === 'assistant' && contextProject && !contextMismatch">
                <i class="fal fa-folder"></i>
                {{ contextProject.title }}
            </div>

            <div class="ai-chat-warning" v-if="!showHistory && contextMismatch">
                <i class="fal fa-exclamation-triangle"></i>
                This conversation is about
                <strong>#{{ conversationContext.id }} {{ conversationContext.name }}</strong>,
                not the page you're viewing.
                <a @click="goToContext">Open {{ conversationContext.type }}</a>
            </div>

            <div class="ai-chat-messages" v-if="showHistory">
                <div v-if="!conversations.length" class="text-muted">
                    No previous conversations.
                </div>
                <a v-for="conversation in conversations"
                   :key="conversation.id"
                   class="ai-chat-conversation"
                   @click="openConversation(conversation)">
                    <span class="ai-chat-conversation-title">{{ conversation.title }}</span>
                    <span class="ai-chat-conversation-meta">
                        {{ agentLabels[conversation.agent] }} · {{ formatDate(conversation.updated_at) }}
                    </span>
                </a>
            </div>

            <div v-if="!showHistory && conversationFiles.length" class="ai-chat-files">
                <i class="fal fa-paperclip"></i> Context files:
                <span v-for="file in conversationFiles" :key="file.id" class="ai-chat-file">
                    <i class="fal" :class="fileIcon(file.kind)"></i> {{ file.name }}
                </span>
            </div>

            <div class="ai-chat-messages" ref="messages" v-if="!showHistory">
                <div v-if="!messages.length" class="text-muted">
                    Ask me anything about Carbon.
                </div>
                <div v-for="(message, index) in messages"
                     :key="index"
                     class="ai-chat-message"
                     :class="message.role"
                     v-html="renderMessage(message)">
                </div>
                <div v-if="sending" class="ai-chat-message assistant">
                    <i class="fal fa-spinner fa-pulse"></i>
                </div>
            </div>

            <div v-if="pendingAttachment" class="ai-chat-pending">
                <i class="fal fa-paperclip"></i> {{ pendingAttachment.name }}
                <a @click="pendingAttachment = null" title="Remove attachment"><i class="fal fa-times"></i></a>
            </div>

            <div class="ai-chat-input">
                <a class="ai-chat-attach" @click="$refs.attachmentInput.click()" title="Attach a small file (PDF, image, text or CSV) - read directly into the conversation">
                    <i class="fal fa-paperclip"></i>
                </a>
                <input type="file"
                       ref="attachmentInput"
                       style="display: none"
                       accept=".pdf,.txt,.csv,image/*"
                       @change="chooseAttachment">
                <input type="text"
                       class="form-control"
                       v-model="draft"
                       placeholder="Type a message..."
                       :disabled="sending"
                       @keyup.enter="send">
                <button class="btn btn-primary" :disabled="sending || !draft.trim()" @click="send">
                    <i class="fal fa-paper-plane"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { http, notify } from 'utils'
import { mapState, mapActions } from 'vuex'
import { AGENT_LABELS, availableAgents, attachmentError, fileIcon, renderMessage } from './chat'

export default {
    data() {
        return {
            open: false,
            expanded: false,
            conversationContext: null,
            draft: '',
            sending: false,
            pendingAttachment: null,
            agent: 'assistant',
            conversationId: null,
            messages: [],
            conversationFiles: [],
            showHistory: false,
            conversations: []
        }
    },

    computed: {
        ...mapState('opportunity', {
            storedOpportunity: 'single'
        }),

        ...mapState('yodizproject', {
            storedProject: 'single'
        }),

        agentLabels() {
            return AGENT_LABELS
        },

        availableAgents() {
            return availableAgents(this.$isA('admin'))
        },

        pageContext() {
            if (this.$route.params.opportunity_id) {
                return { opportunity_id: Number(this.$route.params.opportunity_id) }
            }

            if (this.$route.params.project_id) {
                return { project_id: Number(this.$route.params.project_id) }
            }

            return null
        },

        contextOpportunity() {
            if (this.pageContext && Number(this.storedOpportunity?.id) === this.pageContext.opportunity_id) {
                return this.storedOpportunity
            }

            return null
        },

        contextProject() {
            if (this.pageContext && Number(this.storedProject?.id) === this.pageContext.project_id) {
                return this.storedProject
            }

            return null
        },

        // The opened conversation is about a record other than the one on the
        // current page - replies will still be about the conversation's own
        // record.
        contextMismatch() {
            if (!this.conversationContext) {
                return false
            }

            const key = this.conversationContext.type + '_id'

            return !this.pageContext || this.pageContext[key] !== this.conversationContext.id
        }
    },

    watch: {
        open(open) {
            if (open && !this.messages.length && this.pageContext?.opportunity_id) {
                this.agent = 'sales'
            }
        }
    },

    methods: {
        ...mapActions('opportunity', { getOpportunity: 'getSingle' }),
        ...mapActions('userStoryDocument', ['getUserStoryDocument']),
        ...mapActions('costing', ['getCosting']),

        async send() {
            if (!this.draft.trim() || this.sending) return

            const message = this.draft.trim()
            const attachment = this.pendingAttachment

            this.messages.push({
                role: 'user',
                content: message + (attachment ? '\n📎 ' + attachment.name : '')
            })
            this.draft = ''
            this.pendingAttachment = null
            this.sending = true
            this.scrollToBottom()

            try {
                const form = new FormData()
                form.append('message', message)
                form.append('agent', this.agent)
                if (this.conversationId) form.append('conversation_id', this.conversationId)
                if (this.pageContext?.opportunity_id) form.append('context[opportunity_id]', this.pageContext.opportunity_id)
                if (this.pageContext?.project_id) form.append('context[project_id]', this.pageContext.project_id)
                if (attachment) form.append('attachment', attachment)

                const { data } = await http.post('ai/chat', form, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                })

                this.conversationId = data.data.conversation_id
                this.messages.push({ role: data.data.role, content: data.data.content })
                this.refreshUpdatedContent(data.data.updated_opportunities || [])

                // A new conversation started on an opportunity or project
                // page is grounded to that record - remember it so navigating
                // away shows the mismatch warning.
                if (!this.conversationContext && this.agent === 'sales' && this.contextOpportunity) {
                    this.conversationContext = {
                        type: 'opportunity',
                        id: Number(this.contextOpportunity.id),
                        name: this.contextOpportunity.name,
                    }
                }

                if (!this.conversationContext && this.agent === 'assistant' && this.contextProject) {
                    this.conversationContext = {
                        type: 'project',
                        id: Number(this.contextProject.id),
                        name: this.contextProject.title,
                    }
                }
            } catch (error) {
                if (error.response && error.response.status === 422 && attachment) {
                    notify.error('That attachment is not supported. Attach a small PDF, image, text or CSV file.')
                } else {
                    notify.error('Failed to send message, please try again.')
                }
            } finally {
                this.sending = false
                this.scrollToBottom()
            }
        },

        // Re-fetch the opportunity the user is viewing when the agent has
        // written to it, so the page reflects the change without a reload.
        refreshUpdatedContent(updatedIds) {
            const id = this.pageContext && this.pageContext.opportunity_id

            if (!id || !updatedIds.includes(id)) return

            this.getOpportunity(id).then(() => {
                const usd = this.storedOpportunity && this.storedOpportunity.user_story_document_id

                if (this.$route.name === 'opportunities.costing' && usd) {
                    this.getUserStoryDocument(usd)
                    this.getCosting(usd)
                }
            })
        },

        chooseAttachment(event) {
            const file = event.target.files[0]
            event.target.value = null

            if (!file) return

            const error = attachmentError(file)

            if (error) {
                notify.error(error)
                return
            }

            this.pendingAttachment = file
        },

        reset() {
            this.conversationId = null
            this.messages = []
            this.conversationFiles = []
            this.conversationContext = null
        },

        goToContext() {
            if (this.conversationContext.type === 'project') {
                this.$router.push({
                    name: 'projects.show.details',
                    params: { project_id: this.conversationContext.id },
                })

                return
            }

            this.$router.push({
                name: 'opportunities.overview',
                params: { opportunity_id: this.conversationContext.id },
            })
        },

        startNew() {
            this.showHistory = false
            this.reset()
        },

        async toggleHistory() {
            this.showHistory = !this.showHistory

            if (this.showHistory) {
                try {
                    const { data } = await http.get('ai/conversations')
                    this.conversations = data.data
                } catch (error) {
                    this.conversations = []
                }
            }
        },

        async openConversation(conversation) {
            try {
                const { data } = await http.get(`ai/chat/${conversation.id}`)

                this.agent = conversation.agent
                this.conversationId = conversation.id
                this.messages = data.data.map(message => ({
                    role: message.role,
                    content: message.content
                }))
                this.conversationFiles = data.files || []
                this.conversationContext = data.context || null
                this.showHistory = false
                this.scrollToBottom()
            } catch (error) {
                notify.error('Failed to load conversation, please try again.')
            }
        },

        formatDate(value) {
            return new Date(value).toLocaleDateString()
        },

        renderMessage,

        fileIcon,

        scrollToBottom() {
            this.$nextTick(() => {
                if (this.$refs.messages) {
                    this.$refs.messages.scrollTop = this.$refs.messages.scrollHeight
                }
            })
        }
    }
}
</script>
